import { tracked } from "@glimmer/tracking";
import Controller from "@ember/controller";
import { action } from "@ember/object";
import { getOwner } from "@ember/owner";
import { service } from "@ember/service";

export default class CircleManageProfileController extends Controller {
  @service router;

  @tracked name = null;
  @tracked disableSave = true;

  #oldSlug = null;

  get slug() {
    return this.model.slug;
  }

  @action
  canSave(value = true) {
    this.disableSave = !value;
  }

  @action
  onBeforeSave() {
    this.#oldSlug = this.slug;
  }

  @action
  onAfterSave(savedModel) {
    if (this.slug !== this.#oldSlug) {
      this.router.transitionTo(
        "circle.manage.profile",
        savedModel.slug_path_with_id
      );
    } else {
      getOwner(this).lookup("route:circle").refresh();
    }

    this.#oldSlug = this.slug;
  }
}
